import type OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { UserConfigurationArgs, UserConfiguration, DEFAULT_USER_CONFIG } from 'owa-graph-schema';
import * as trace from 'owa-trace';
import { convertUserConfigToGraphQLSchema } from './utils/convertUserConfigToGraphQLSchema';
import merge from 'lodash-es/merge';

const cache = new Map<string, UserConfiguration>();

export function setConfiguration(
    configuration: OwaUserConfiguration | undefined,
    userConfigId?: string,
    merge?: boolean
) {
    userConfigId = userConfigId || DEFAULT_USER_CONFIG;

    try {
        if (configuration) {
            const configCopy = JSON.parse(JSON.stringify(configuration));
            const config = convertUserConfigToGraphQLSchema(configCopy, userConfigId);
            if (merge) {
                updateConfiguration(userConfigId, config);
            } else {
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS7053 (26,17): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Map<string, UserConfiguration>'.
                // @ts-expect-error
                cache[userConfigId] = config;
            }
        }
    } catch (e) {
        trace.errorThatWillCauseAlert('User configuration cache set failed: ' + e);
    }
}

export function getConfiguration(userConfigId?: string | null): UserConfiguration {
    userConfigId = userConfigId || DEFAULT_USER_CONFIG;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7053 (39,12): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Map<string, UserConfiguration>'.
    // @ts-expect-error
    return cache[userConfigId] || { id: userConfigId };
}

export function updateConfiguration(userConfigId?: string | null, updates?: UserConfigurationArgs) {
    if (updates) {
        userConfigId = userConfigId || DEFAULT_USER_CONFIG;
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7053 (48,26): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Map<string, UserConfiguration>'.
        // @ts-expect-error
        const existing = cache[userConfigId] || {};
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS7053 (52,9): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Map<string, UserConfiguration>'.
        // @ts-expect-error
        cache[userConfigId] = merge(existing, updates);
    }
}
